import { Link } from 'react-router-dom';

export function SectionLink({ to, children, className = '' }) {
  return (
    <Link
      to={to}
      className={`inline-flex items-center text-secondary font-medium hover:underline ${className}`}
    >
      {children}
      <i className="fa fa-arrow-right ml-2 text-sm" />
    </Link>
  );
}
